import dayJS from 'dayjs';
/**
 * 根据订单类型返回不同class
 * @param value 订单类型
 */
export function orderStatusColor(value) {
  switch(value) {
    case 0:
      return '#F59A23';
    case 1:
      return '#339900';
    case 2:
      return '#969799';
    default:
      return '';
  }
}

export const currentMonth = dayJS().subtract(0, 'month').format('YYYY-MM');
/**
 * 获取每月1号时间戳
 * @param date 当月
 */
export function getMonthStartTime(date) {
  return (dayJS(date).startOf('month').valueOf() / 1000) | 0 || undefined;
}
/**
 * 获取每月最后一天时间戳
 * @param date 当月
 */
export function getMonthEndTime(date) {
  return (dayJS(date).endOf('month').valueOf() / 1000) | 0 || undefined;
}

export function dateFormat(date) {
  if (!date) return '--'
  return dayJS(new Date(date * 1000)).format('YYYY-MM-DD HH:mm:ss')
}

// 电话正则
// export const telRegExp = /^(?:\+?86)?1(?:3\d{3}|5[^4\D]\d{2}|8\d{3}|7(?:[235-8]\d{2}|4(?:0\d|1[0-2]|9\d))|9[0-35-9]\d{2}|66\d{2})\d{6}$/;
export const telRegExp = /^1\d{10}$/;

// 千分位
export function toThousandFilter(num) {
  return (+num || 0).toString().replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
}

// 微信公众号appID
export const appId = 'wxf881d0e41dc44e79';

// 高德地图web服务接口key
export const WEB_KEY = '25079bce0758ed1cbc660eeb402fb860'

//高德地图js_api接口key
export const JS_KEY = '4d13aa1377bdbdbcbdf263b81281b6aa'

/**
 * 动态加载高德地图
 * 
 * @param {*} key 高德地图key
 * @param {*} plugins 高德地图插件
 * @param {string} [v='1.4.14'] 高德地图版本
 */
export const loadMap = (key = JS_KEY, v = '2.0') => {
  return new Promise((resolve) => {
    if (typeof window.AMap !== 'undefined' && typeof window.AMapUI !== 'undefined') {
      resolve(window.AMap)
    }
    window.initMap = () => {
      const mapUi = document.createElement('script')
      mapUi.type = 'text/javascript'
      mapUi.src = "https://webapi.amap.com/ui/1.1/main.js?v=1.1.1"
      document.head.appendChild(mapUi)
      mapUi.onload = () => {
        resolve(window.AMap)
      }
    }
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = `https://webapi.amap.com/maps?v=${v}&key=${key}&callback=initMap`
    document.head.appendChild(script)
  })
}
